import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  ChatListDataContext,
  GroupDataContext,
  SignalRContext,
  UsersDataContext,
} from "../../layout/Baselayout";
import defaultUserPic from "../../assets/img/user-profile.svg";
import groupPic from "../../assets/img/multi-user-icon.svg";
import outgoing from "../../assets/img/outgoing-call.png";
import incoming from "../../assets/img/incoming-call.png"
import missed from "../../assets/img/rejected.png"
import NewGroup from "../newGroup/NewGroup";
import * as chatService from "../../services/chatService";
import { formatDate, formatTime, getCurrentToISOStringDate, getFormattedDateTime, parseDate } from "../../utils";
import { logoutUser } from "../../services/authService";
import sendNotification from "../notification/Notification";
import UserProfileModal from "../../utils/UserProfileModal";
import { SocketContext } from "../../services/socketContext";
import Modal from "../../utils/Modal";


const ChatList = () => {
  const { socket } = useContext(SocketContext);
  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const usersData = useContext(UsersDataContext);
  const [activeGroups, setActiveGroups, allUserList, allGroupList] = useContext(GroupDataContext);
  const [connection, onlineUsers] = useContext(SignalRContext)
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  const roomIdRef = useRef(null);
  const { id } = useParams();
  const roomId = id?.split("_")[0];
  const filteredCombinedChatsRef = useRef({});
  const [CallLogs,setCallLogs] = useState([]);

  // const [activeChats, setActiveChats] = useState([]);
  const [isNewChatVisible, setIsNewChatVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const {chatListItem, setChatListItem, activeChats, setActiveChats, activeChatList} = useContext(ChatListDataContext);
  const [openNewGroupModal, setOpenNewGroupModal] = useState(false);
  // const [unreadMessages, setUnreadMessages] = useState({});
  const [combinedChats, setCombinedChats] = useState([]);
  const [filteredCombinedChats, setFilteredCombinedChats] = useState([]);
  const [newUsers, setNewUsers] = useState([]);
  const [searchUser, setSearchUser] = useState("");
  const [isChatView, setIsChatView] = useState(true);
  const [callLogToDelete, setCallLogToDelete] = useState(null);
  const [currChatUser, setCurrChatUser] = useState({});
  const [modalAction, setModalAction] = useState({
    createGroup: false,
    viewProfile: false,
  });

  const callStatus={
    0: {
      icon: missed,
      label: "Missed Call",
      className: "call-missed"
    },
    1: {
      icon: incoming,
      label: "Incoming Call",
      className: "call-incoming"
    },
    2: {
      icon: outgoing,
      label: "Outgoing Call",
      className: "call-outgoing"
    }
  }

    useEffect(() => {
      if (id) {
        const userId = id.split("_")[1];
        const currChatUser = usersData?.find(
          (user) => user.id.toString() === userId
        );
        setCurrChatUser(currChatUser);
      }
    }, [id, usersData]);

  useEffect(() => {
    filteredCombinedChatsRef.current = filteredCombinedChats; // Keep the ref updated with the latest state
  }, [filteredCombinedChats]);

  useEffect(() => {
    if (!chatListItem) return;

    const { type, id, roomId, userName, groupName, lastMessageDate, message } =
      chatListItem;

    if ( type === "add-chat-item-fwd" ) {
      const isChat = (type === "add-chat-item" && type !== "add-chat-item-fwd");
      const itemExists = filteredCombinedChatsRef.current.some((item) => item.id === id && item.roomId === roomId)

      if (!itemExists) {
        const updateChats = (chats) => {
          return chats.sort(
            (a, b) => new Date(b.lastMessageDate) - new Date(a.lastMessageDate)
          );
        };

        const newItem = {
          id,
          roomId: roomId ? roomId : roomIdRef.current,
          userName: userName,
          lastMessageDate: lastMessageDate || "",
          type: "single-chat",
          message:message
        };
        setFilteredCombinedChats((prev) => updateChats([...prev, newItem]));
        setCombinedChats((prev) => updateChats([...prev, newItem]));
        setActiveChats((prev) => updateChats([...prev, newItem]));

        if (isChat) {
          navigate(`chat/${newItem.roomId}_${id}`);
        }
      } else {

      }
    } else if (type === "update-group-item") {
      setFilteredCombinedChats((prevChats) => {
        const updatedChats = prevChats.map((chat) => {
          if (chat.id === id) {
            return {
              ...chat,
              userName: groupName,
            };
          }
          return chat;
        });
        return updatedChats;

      });
    }
    else if (type === "leave-group-item") {

      const updateChats = (chats, id) => {
        return chats
          .filter((item) => item.id.toString() !== id.toString()) // Remove item with matching id
          .sort((a, b) => new Date(b.lastMessageDate) - new Date(a.lastMessageDate)); // Sort by lastMessageDate in descending order
      };

      setCombinedChats((prevChats) => updateChats(prevChats, id));
      setFilteredCombinedChats((prevChats) => updateChats(prevChats, id));
      setActiveChats((prevChats) => updateChats(prevChats, id));
    }

    setChatListItem(null);
  }, [chatListItem]);

  useEffect(() => {
    if (!connection) return;

    const handleReceiveMessage = (data) => {
      roomIdRef.current = data.roomId
      if (data.receiverId.toString() === loginData.id.toString()) {
        //send notification
        sendNotification({
          title: data.senderName,
          message: data.message.replace(/.*\/(.*)_[^_]+(\.[^.]+$)/, '$1$2'),
          onClick: () => {
            console.log('Notification clicked!');
            window.focus(); // or navigate to chat window
          },
        });
        const currentChatId = `${data.roomId}_${data.senderId}`;

        const isActiveChat =
          window.location.pathname === `/chat/${currentChatId}`;

        const itemExists = filteredCombinedChatsRef.current.some((item) => item.id === data.senderId && item.roomId === data.roomId);
        if (!itemExists) {
          const updateChats = (chats) => { return chats };
          const newItem = {
            id: data.senderId,
            roomId: data.roomId,
            userName: data.senderName,
            chatCount: isActiveChat ? 0 : 1,
            lastMessageDate: getFormattedDateTime(),
            message: data.message ? data.message : data.mediaUrl,
          };
          setActiveChats((prev) => updateChats([...prev, newItem]));
        } else {
          setActiveChats((prevChats) => {
            const updatedChats = [...prevChats];
            const chatIndex = updatedChats.findIndex(
              (item) => item.id === data.senderId && item.roomId === data.roomId
            );

            if (chatIndex !== -1) {
              const existingChat = updatedChats[chatIndex];
              updatedChats[chatIndex] = {
                ...existingChat,
                lastMessageDate: getFormattedDateTime(),
                chatCount: isActiveChat ? 0 : (existingChat.chatCount || 0) + 1,
                message: data.message ? data.message : data.mediaUrl,
              };
            }
            return updatedChats;
          });
        }

        setFilteredCombinedChats((prevChats) => {
          const chatIndex = prevChats.findIndex(
            (chat) =>
              chat.id.toString() === data.senderId.toString() && chat.roomId === data.roomId
          );

          if (chatIndex === -1) {

            // Add new chat if it doesn't exist
            return [
              ...prevChats,
              {
                id: parseInt(data.senderId, 10),
                userName: data.senderName,
                roomId: data.roomId,
                lastMessageDate: getFormattedDateTime(),
                type: "single-chat",
                chatCount: isActiveChat ? 0 : 1,
                message: data.message ? data.message : data.mediaUrl,
                // unreadMessage: isActiveChat ? "" : data.message
              },
            ].sort(
              (a, b) =>
                parseDate(b.lastMessageDate) - parseDate(a.lastMessageDate)
            );
          }
          else {
            // Update existing chat
            const updatedChats = [...prevChats];
            const existingChat = updatedChats[chatIndex];

            updatedChats[chatIndex] = {
              ...existingChat,
              lastMessageDate: getFormattedDateTime(),
              chatCount: isActiveChat
                ? 0 // Reset unread count if in active chat
                : (existingChat.chatCount || 0) + 1, // Increment unread count
              // unreadMessage: isActiveChat ? "" : data.message
              message: data.message ? data.message : data.mediaUrl,
            };

            return updatedChats.sort(
              (a, b) =>
                parseDate(b.lastMessageDate) - parseDate(a.lastMessageDate)
            );
          }
        });
        setCombinedChats((prevChats) => {
          const chatIndex = prevChats.findIndex(
            (chat) =>
              chat.id.toString() === data.senderId.toString() && chat.roomId === data.roomId
          );

          if (chatIndex === -1) {

            // Add new chat if it doesn't exist
            return [
              ...prevChats,
              {
                id: parseInt(data.senderId, 10),
                userName: data.senderName,
                roomId: data.roomId,
                lastMessageDate: getFormattedDateTime(),
                type: "single-chat",
                chatCount: isActiveChat ? 0 : 1,
                message: data.message ? data.message : data.mediaUrl,
                // unreadMessage: isActiveChat ? "" : data.message
              },
            ].sort(
              (a, b) =>
                parseDate(b.lastMessageDate) - parseDate(a.lastMessageDate)
            );
          }
          else {
            // Update existing chat
            const updatedChats = [...prevChats];
            const existingChat = updatedChats[chatIndex];

            updatedChats[chatIndex] = {
              ...existingChat,
              lastMessageDate: getFormattedDateTime(),
              chatCount: isActiveChat
                ? 0 // Reset unread count if in active chat
                : (existingChat.chatCount || 0) + 1, // Increment unread count
              message: data.message ? data.message : data.mediaUrl,
              // unreadMessage: isActiveChat ? "" : data.message
            };

            return updatedChats.sort(
              (a, b) =>
                parseDate(b.lastMessageDate) - parseDate(a.lastMessageDate)
            );
          }
        });

      } else {
        const updateChats = (chats) => {
          const chatIndex = chats.findIndex(chat => chat.roomId === data.roomId);
        
          if (chatIndex === -1) {
            //add user in chatlist for current screen 
            const newItem = {
              id : data.receiverId,
              roomId: data.roomId,
              userName: currChatUser?.userName,
              lastMessageDate: getFormattedDateTime(),
              type: "single-chat",
              message: data.message ? data.message : data.mediaUrl,
            };
            return [...chats, newItem].sort(
              (a, b) => new Date(b.lastMessageDate) - new Date(a.lastMessageDate)
            );
          }
        
          const updatedChat = {
            ...chats[chatIndex],
            lastMessageDate: getFormattedDateTime(),
            message: data.message ? data.message : data.mediaUrl,
          };
        
          return [
            updatedChat,
            ...chats.slice(0, chatIndex),
            ...chats.slice(chatIndex + 1),
          ];
        };
        
        setFilteredCombinedChats(prevChats => updateChats(prevChats));
        setCombinedChats(prevChats => updateChats(prevChats));
        setActiveChats(prevChats => updateChats(prevChats));
        const isChat = roomId === "new"
        // if (isChat) {
          navigate(`chat/${data.roomId}_${data.receiverId}`);
        // }
        
      }
    };
    connection?.on("ReceiveMessage", handleReceiveMessage);

    return () => {
      connection?.off("ReceiveMessage", handleReceiveMessage);
    };
  }, [connection,currChatUser]);

  useEffect(()=>{
    const handleReceiveRoomMessage = (data) => {
      if (data.receiverId === 0 && data.senderId !== loginData.id) {
        //send notification
        sendNotification({
          title: data.groupName,
          message: `${data.senderName}: ${data.message?.replace(/.*\/(.*)_[^_]+(\.[^.]+$)/, '$1$2')}`,
          onClick: () => {
            console.log('Notification clicked!');
            window.focus(); // or navigate to chat window
          },
        });
        const isActiveChat = data?.roomId === id?.split('_')[0]; // Check if the current room is active
        
        const itemExists = filteredCombinedChatsRef.current.some((item) => item.id === data.groupId && item.roomId === data.roomId);

        if (!itemExists) {
          const updateChats = (chats) => {
            return chats;
          };
          const newItem = {
            id: data.groupId,
            roomId: data.roomId,
            groupName: data.groupName,
            chatCount: isActiveChat ? 0 : 1,
            lastMessageDate: getFormattedDateTime(),
            message: data.message ? data.message : data.mediaUrl,
          };
          setActiveGroups((prev) => updateChats([...prev, newItem]));
        } else {
          setActiveGroups((prevGroups) => {
            const updatedGroups = [...prevGroups];
            const groupIndex = updatedGroups.findIndex(
              (item) => item.id === data.groupId && item.roomId === data.roomId
            );

            if (groupIndex !== -1) {
              const existingGroup = updatedGroups[groupIndex];
              updatedGroups[groupIndex] = {
                ...existingGroup,
                lastMessageDate: getFormattedDateTime(),
                chatCount: isActiveChat ? 0 : (existingGroup.chatCount || 0) + 1,
                message: data.message ? data.message : data.mediaUrl,
              };
            }

            return updatedGroups;
          });
        }

        setFilteredCombinedChats((prevChats) => {
          const chatIndex = prevChats.findIndex((chat) => chat.roomId === data.roomId);

          if (chatIndex !== -1) {
            // Update the existing chat count and lastMessageDate
            const updatedChats = [...prevChats];
            const existingChat = updatedChats[chatIndex];

            updatedChats[chatIndex] = {
              ...existingChat,
              lastMessageDate: getFormattedDateTime(),
              chatCount: isActiveChat ? 0 : (existingChat?.chatCount || 0) + 1, // Increment unread count
              message: data.message ? data.message : data.mediaUrl,
            };

            return updatedChats.sort(
              (a, b) => parseDate(b.lastMessageDate) - parseDate(a.lastMessageDate)
            );
          } else {
            return [
              ...prevChats,
              {
                id: data.groupId,
                userName: data.groupName,
                roomId: data.roomId,
                lastMessageDate: getFormattedDateTime(),
                type: "group-chat",
                chatCount: isActiveChat ? 0 : 1,
                message: data.message ? data.message : data.mediaUrl,
                // unreadMessage: isActiveChat ? "" : data.message
              },
            ].sort(
              (a, b) =>
                new Date(b.lastMessageDate) - new Date(a.lastMessageDate)
            );

          }
        });
        setCombinedChats((prevChats) => {
          const chatIndex = prevChats.findIndex((chat) => chat.roomId === data.roomId);

          if (chatIndex !== -1) {
            // Update the existing chat count and lastMessageDate
            const updatedChats = [...prevChats];
            const existingChat = updatedChats[chatIndex];

            updatedChats[chatIndex] = {
              ...existingChat,
              lastMessageDate: getFormattedDateTime(),
              chatCount: isActiveChat ? 0 : (existingChat?.chatCount || 0) + 1, // Increment unread count
              message: data.message ? data.message : data.mediaUrl,
            };

            return updatedChats.sort(
              (a, b) => parseDate(b.lastMessageDate) - parseDate(a.lastMessageDate)
            );
          } else {
            return [
              ...prevChats,
              {
                id: data.groupId,
                userName: data.groupName,
                roomId: data.roomId,
                lastMessageDate: getFormattedDateTime(),
                type: "group-chat",
                chatCount: isActiveChat ? 0 : 1,
                message: data.message ? data.message : data.mediaUrl,
                // unreadMessage: isActiveChat ? "" : data.message
              },
            ].sort(
              (a, b) =>
                new Date(b.lastMessageDate) - new Date(a.lastMessageDate)
            );

          }
        });
      } else {
        //  setFilteredCombinedChats((prevChats) => {
        //    const updatedChats = prevChats.map((chat) => {
        //      if (chat.roomId === data.roomId) {
        //        return {
        //          ...chat,
        //          lastMessageDate: getFormattedDateTime(),
        //        };
        //      }
        //      return chat;
        //    });

        //    return updatedChats.sort(
        //      (a, b) => parseDate(b.lastMessageDate) - parseDate(a.lastMessageDate)
        //    );
        //  });
        const updateChats = (chats) => {
          // Find the index of the chat to update
          const chatIndex = chats.findIndex(chat => chat.roomId === data.roomId);

          if (chatIndex === -1) return chats; // if not found, return original

          // Create a new array with the updated chat moved to front
          return [
            {
              ...chats[chatIndex],
              lastMessageDate: getFormattedDateTime(),
              message: data.message ? data.message : data.mediaUrl,
            },
            ...chats.slice(0, chatIndex),
            ...chats.slice(chatIndex + 1)
          ];
        };

        setFilteredCombinedChats(prevChats => updateChats(prevChats));
        setCombinedChats(prevChats => updateChats(prevChats));
        setActiveGroups(prevChats => updateChats(prevChats));
      }
    }
    connection?.on("ReceiveRoomMessage", handleReceiveRoomMessage);
    return () => {
      connection?.off("ReceiveRoomMessage", handleReceiveRoomMessage);
    };
  },[connection,id])

  useEffect(() => {
    const updateChats = (chats, roomId) =>
      chats
        .filter((item) => item.roomId.toString() !== roomId?.toString())
        .sort((a, b) => new Date(b.lastMessageDate) - new Date(a.lastMessageDate));


    const handleCreateGroup = (chat) => {
      if (chat.users.includes(loginData.id)) {
        const updateChats = (chats) => {
          return chats.sort(
            (a, b) => parseDate(b.lastMessageDate) - parseDate(a.lastMessageDate)
          );
        };

        const newItem = {
          id: chat.id,
          roomId: chat.roomId,
          userName: chat.groupName,
          lastMessageDate: getFormattedDateTime(chat.createdAt),
          type: "group-chat",
        };
        setFilteredCombinedChats((prev) => updateChats([...prev, newItem]));
        setCombinedChats((prev) => updateChats([...prev, newItem]));
        setActiveGroups((prev) => [...prev, chat]);
      }
    }

    const handleClearHistoryUser = (roomId, clearuserid, userId) => {
      if (roomId) {
        setCombinedChats((prevChats) => updateChats(prevChats, roomId));
        setFilteredCombinedChats((prevChats) => updateChats(prevChats, roomId));
        setActiveChats((prevChats) => updateChats(prevChats, roomId));

        if (`/chat/${roomId}_${userId}` === window.location.pathname) {
          navigate("/chat");
        }
      }
    };

    const handleDeleteGroupId = (roomId, groupId, createdBy) => {
      if (roomId) {
        setCombinedChats((prevChats) => updateChats(prevChats, roomId));
        setFilteredCombinedChats((prevChats) => updateChats(prevChats, roomId));
        setActiveGroups((prevChats) => updateChats(prevChats, roomId));

        if (`/chat/${roomId}_${groupId}` === window.location.pathname) {
          navigate("/chat");
        }
      }
    };

    const handleLastMessage = (lastMessage,lastMessageDate,roomId) => {
      const updateChats = (chats) =>
        chats.map(chat =>
          chat.roomId === roomId
            ? {
              ...chat,
              message: lastMessage,
              lastMessageDate: getFormattedDateTime(lastMessageDate),
            }
            : chat
        );

      setActiveGroups(updateChats);
      setActiveChats(updateChats);
    }

    connection.on("ClearHistoryUser", handleClearHistoryUser);
    connection.on("DeleteGroupId", handleDeleteGroupId);
    connection.on("CreateGroup", handleCreateGroup);
    connection.on("UpdateLastMessage", handleLastMessage);

    // Cleanup to prevent memory leaks
    return () => {
      connection.off("ClearHistoryUser", handleClearHistoryUser);
      connection.off("DeleteGroupId", handleDeleteGroupId);
      connection.off("CreateGroup", handleClearHistoryUser);
    };
  }, [connection]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleView = (view) => {
    setIsChatView(view === 'chat');
    if(view === 'call')
    {
      getCallLogs();
    }
  };

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    const combined = [
      ...(Array.isArray(activeChats) ? activeChats : [])
        .map((chat) => {
          if (chat.id !== loginData?.id) {
            return {
              id: chat.id,
              roomId: chat.roomId,
              userName: chat.userName,
              lastMessageDate: getFormattedDateTime(chat.lastMessageDate) === "Invalid Date" ? chat.lastMessageDate : getFormattedDateTime(chat.lastMessageDate),
              chatCount: chat.chatCount,
              message: chat.message,
              type: "single-chat",
            };
          }
          return undefined;
        })
        .filter((chat) => chat !== undefined),
      ...(Array.isArray(activeGroups) ? activeGroups : []).map((group) => ({
        id: group.id,
        roomId: group.roomId,
        userName: group.groupName,
        lastMessageDate: group?.lastMessageDate
          ? getFormattedDateTime(group.lastMessageDate) === "Invalid Date"
            ? group?.lastMessageDate
            : getFormattedDateTime(group?.lastMessageDate)
          : getFormattedDateTime(group?.createdAt),
        chatCount: group.chatCount,
        message: group.message? group.message : group.lastMessage,
        type: "group-chat",
      })),
    ];

    const sortedCombined = combined.sort(
      (a, b) => parseDate(b.lastMessageDate) - parseDate(a.lastMessageDate)
    );

    setCombinedChats(sortedCombined);
    setFilteredCombinedChats(sortedCombined);
  }, [activeChats, activeGroups]);

  const handleOnSearch = (event) => {
    const searchData = event.target.value;
    setSearchUser(searchData);
    const filterArray = isNewChatVisible ? usersData : combinedChats
    const filterData = filterArray?.filter((item) => {
      return item.userName.toLowerCase().includes(searchData?.toLowerCase());
    });
    isNewChatVisible ? setNewUsers(filterData) : setFilteredCombinedChats(filterData);
  };

  useEffect(() => {
    setNewUsers(usersData);
  }, [usersData]);


  const resetChatCount = (chats, currentChatId) => {
    return chats.map((chat) =>
      `${chat.roomId}_${chat.id}` === currentChatId
        ? { ...chat, chatCount: 0, unreadMessage: "" }
        : chat
    );
  };

  const resetUnreadMessageCount = async () => {
    const data = {
      roomid: roomId,
      userid: loginData?.id,
      chatCount: 0,
    };

    // const activeChat = filteredCombinedChats?.find((chat) => chat.roomId === roomId);

    // if (activeChat) {
    try {
      let response = await chatService.resetUnreadChatCount(data);
      if (response.status === 200) {
        let result = await response.json();

        const currentChatId = id;
        setFilteredCombinedChats((prevChats) => resetChatCount(prevChats, currentChatId));
        setCombinedChats((prevChats) => resetChatCount(prevChats, currentChatId));
        setActiveChats((prevChats) => resetChatCount(prevChats, currentChatId));
        setActiveGroups((prevChats) => resetChatCount(prevChats, currentChatId));
      }
    } catch (error) {
      console.log("Error reset count api", error);

    }

  };
  const getCallLogs = async() =>{
    await chatService.getCallLog(loginData.id)
    .then((response)=>{
        setCallLogs(response)
    })
  }
  
  
  useEffect(() => {
    if (id) {
      resetUnreadMessageCount();
    }
  }, [id]);

  const onIsNewChatVisible = () => {
    setIsNewChatVisible(true);
    setSearchUser("");
    allUserList();
    const mergedChats = combinedChats.map(chat => {
      const updatedChat = filteredCombinedChatsRef.current.find(
        updated => updated.id === chat.id
      );
      if (updatedChat) {
        return { ...chat, chatCount: updatedChat.chatCount, lastMessageDate: updatedChat.lastMessageDate };
      }
      return chat;
    });

    setFilteredCombinedChats(mergedChats);
  }

  const onIsNewChatHide = () => {
    setIsNewChatVisible(false);
    setSearchUser("");
  }

  const isNavigate = (userId) => {
    const chatExists = filteredCombinedChats?.find(
      (chat) => chat.id.toString() === userId
    );
    navigate(
      chatExists
        ? `chat/${chatExists?.roomId}_${chatExists.id}`
        : `chat/new_${userId}`
    );
    setIsNewChatVisible(false);
    setNewUsers(usersData);
    setSearchUser("");
  };

  const closeModal = () => {
    setModalAction({});
  };

  // useEffect(() => {
  //   return async()=>{
  //     const data = {
  //       roomid: roomId,
  //       userid: loginData?.id,
  //       chatCount: 0,
  //     };
  //     await chatService.resetUnreadChatCount(data);;

  //   }
  // },[id])

  //logout user
  const handleLogout = async () => {
    const data = {
      userName: loginData.userName,
      password: loginData.password,
      fcmToken: '',
      devicestypes: "web"
    }
    try {
      const res = await logoutUser(data);
      if (res.status === 200) {
        localStorage.removeItem("loginData");
        localStorage.removeItem("token");
        localStorage.removeItem("users");
        socket.disconnect();
        navigate("/chat");
      }
    } catch (error) {
      console.error("error", error);
    }
  };

useEffect(() => {
    connection.on("Deactivateuser", (userId, userName) => {
      if (userId === loginData.id) {
        window.location.href = "/"
      } else {
        if (userId == id?.split("_")[1]) {
          navigate("chat")
        }
        setActiveChats(chat => chat.filter(chat => chat.id !== userId));
        // setActiveGroups(chat => chat.filter(chat => chat.id !== userId));
      }
    });
    connection.on("DeleteForUser", (userId, userName) => {
      console.log('userId userName',userId,userName);
      if (userId === loginData.id) {
        window.location.href = "/"
      } else {
        if (userId == id?.split("_")[1]) {
          window.location.href = "/chat"
        }
        setFilteredCombinedChats(chat => chat.filter(chat => chat.id !== userId));
        setCombinedChats(chat => chat.filter(chat => chat.id !== userId));
        setActiveChats(chat => chat.filter(chat => chat.id !== userId));
        setActiveGroups(chat => chat.filter(chat => chat.id !== userId));
      }
    });

    connection.on("LogoutFromAdmin", (userId, userName) => {
      console.log('userName',userName);
      
      if (userId === loginData.id) {
        window.location.href = "/"
        localStorage.removeItem("loginData");
        localStorage.removeItem("token");
        localStorage.removeItem("users");
        socket.disconnect();
      } 
    });

  }, [connection,id]);

  const handleDeleteCallLog = (callId) => {
    setCallLogToDelete(callId);
    setModalAction({ ...modalAction, deleteCallLog: true });
  };
  const confirmDeleteCallLog = async () => {
    try {
      await chatService.deletcallLog(callLogToDelete);
      setCallLogs((prev) => prev.filter(log => log.id !== callLogToDelete));
      setModalAction({ ...modalAction, deleteCallLog: false });
      setCallLogToDelete(null);
    } catch (error) {
      console.error("Failed to delete call log:", error);
    }
  };

  return (
    <>
      <div className={`side-one`}>
        <div className="row heading">
          <div className="col-sm-3 col-xs-3 heading-avatar">
            <div
              className="heading-avatar-icon"
              onClick={() =>
                setModalAction({ ...modalAction, viewProfile: true })
              }
            >
              <img src="https://bootdey.com/img/Content/avatar/avatar1.png" />
            </div>
            {/* <span>{loginData?.userName}</span> */}
          </div>
          <div className="col-sm-1 col-xs-1  heading-dot  pull-right dropdown">
            <i
              ref={buttonRef}
              className="fa fa-ellipsis-v fa-2x  pull-right"
              aria-hidden="true"
              onClick={toggleDropdown}
            />
            {/* <i
              className="fa fa-2x fa-phone mr-2 pull-right"
              aria-hidden="true"
              onClick={() => onIsNewChatVisible()}
            ></i> */}
            {/* <i className="fa fa-ellipsis-v fa-2x  pull-right" aria-hidden="true" onClick={handleLogout} ></i> */}
          </div>
          {isOpen && (
            <div className="dropdown-new" ref={dropdownRef}>
              <ul>
                <li onClick={()=> {activeChatList(); setIsOpen(false);}}>Refresh</li>
                <li
                  onClick={() =>
                    setModalAction({ ...modalAction, createGroup: true })
                  }
                >
                  New Group
                </li>
                {/* <li>Starred Massages</li>
                  <li>Select Chat</li> */}
                <li onClick={handleLogout}>Logout</li>
              </ul>
            </div>
          )}
          <div className="col-sm-2 col-xs-2 heading-compose  pull-right">
            <i
              className="fa fa-comments fa-2x  pull-right"
              aria-hidden="true"
              onClick={() => onIsNewChatVisible()}
            ></i>
          </div>
          <div className="col-sm-2 col-xs-2 heading-compose  pull-right"></div>
        </div>

        <div className="row searchBox">
          <div className="col-sm-12 searchBox-inner">
            <div className="form-group has-feedback">
              <input
                id="searchText"
                type="text"
                className="form-control"
                name="searchText"
                placeholder="Search"
                value={searchUser}
                onChange={handleOnSearch}
              />
              <span className="glyphicon glyphicon-search form-control-feedback"></span>
            </div>
          </div>
        </div>
        <div className="cl-button-container">
          <button
            onClick={() => toggleView("chat")}
            className={`filter-button ${isChatView ? "active" : ""}`}
          >
            Chat
          </button>
          <button
            onClick={() => toggleView("call")}
            className={`filter-button ${!isChatView ? "active" : ""}`}
          >
            Call Log
          </button>
        </div>
        {/* ----------------------------------- Active chats ----------------------------------- */}
        <div className="row sideBar">
          {isChatView ? (
            <>
              {filteredCombinedChats?.map((user, index) => (
                <div
                  className="row sideBar-body"
                  key={user.id}
                  onClick={() => navigate(`chat/${user?.roomId}_${user.id}`)}
                >
                  <div className="col-sm-12 col-xs-12 sideBar-main">
                    <div className="row">
                      <div className="col-sm-9 col-xs-8 sideBar-name d-flex">
                        <div className="avatar-icon widthicon60 avatar-container">
                          <img
                            src={
                              user?.type === "single-chat"
                                ? user.avatar
                                  ? user.avatar
                                  : defaultUserPic
                                : groupPic
                            }
                            alt={user?.userName}
                          />
                          {user?.type === "single-chat" && (
                            onlineUsers.includes(user.id.toString()) ? (
                              <span className="online-badge"></span>
                            ) : (
                              <span className="offline-badge"></span>
                            )
                          )}
                        </div>
                        <div className="leftgap">
                          <div>
                            <span
                              className="name-meta"
                              style={{ fontWeight: "bold" }}
                            >
                              {user?.userName}
                            </span>
                          </div>
                          <div className="name-meta f-12">
                            {/* {user?.unreadMessage} */}
                            {user?.message?.replace(/.*\/(.*)_[^_]+(\.[^.]+$)/, '$1$2')}
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-3 col-xs-4 pull-right sideBar-time">
                        <span className="time-meta pull-right">
                          {formatDate(user?.lastMessageDate) === "Today" ? formatTime(user?.lastMessageDate) : formatDate(user?.lastMessageDate) }
                          {/* {formatTime(user?.lastMessageDate)} */}
                        </span>
                        {/* <span className="time-meta pull-right">
                          {user?.message}
                        </span> */}
                        {user.chatCount > 0 && (
                          <span className="notification pull-right">
                            {user.chatCount}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              <div className="panel-height"></div>
            </>
          ) : (
            <>
              {CallLogs && CallLogs.length > 0 ? (
                CallLogs.map((call) => (
                  <div
                    key={call.id}
                    className="row sideBar-body"
                    onDoubleClick={() => handleDeleteCallLog(call.id)}
                  >
                    <div className="col-sm-12 col-xs-12 sideBar-main">
                      <div className="row">
                        <div className="col-sm-9 col-xs-8 sideBar-name d-flex">
                          <div className="avatar-icon widthicon60">
                            <img src={defaultUserPic} alt={call.userName} />
                          </div>
                          <div className="leftgap">
                            <div>
                              <span className="name-meta" style={{ fontWeight: "bold" }}>{call.userName}</span>
                            </div>
                            <div
                              className={`name-meta f-12 call-${call.status}`}
                            >
                              {callStatus[call.status] && (
                                <span
                                  className={`call-detail ${
                                    callStatus[call.status].className
                                  }`}
                                  style={
                                    call.status === 0 ? { color: "red" } : {}
                                  }
                                >
                                  <img
                                    src={callStatus[call.status].icon}
                                    alt={callStatus[call.status].label}
                                    className="call-icon"
                                  />
                                  {callStatus[call.status].label}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-3 col-xs-4 pull-right sideBar-time">
                          <div>

                          <span className="time-meta pull-right">
                            {formatDate(call.createAt)}
                          </span>
                          <span className="time-meta pull-right">
                            {formatTime(call.createAt)}
                          </span>
                          {call.durationReadable && (
                            <span className="call-duration time-meta color-black pull-right">
                              <strong>{call.durationReadable}</strong>
                            </span>
                          )}
                          </div>
                        </div>
                        {/* <div className="col-sm-3 col-xs-4 sideBar-time " >
                          <div className="d-flex justify-content-between align-items-start">
                            <div className="text-right" style={{ marginRight: '9px' }}>
                              <span className="time-meta d-block">{formatTime(call.createAt)}</span>
                              {call.durationReadable && (
                                <span className="call-duration time-meta text-dark d-block">
                                  <strong>{call.durationReadable}</strong>
                                </span>
                              )}
                            </div>
                            <i className="fa fa-trash-o" style={{  alignSelf: 'center', fontSize: '20px'}}  aria-hidden="true"  onClick={() => handleDeleteCallLog(call.id)}></i>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="no-call-logs text-center mt-3 text-muted">
                  <span>No call logs available</span>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      {/* ----------------------------------- Users list for new chat ----------------------------------- */}
      <div
        className={`side-two ${isNewChatVisible ? "show-panel" : "hide-panel"}`}
      >
        <div className="row newMessage-heading">
          <div className="row newMessage-main">
            <div className="col-sm-12 col-xs-12 newMessage-title">
              <i
                className="fa fa-arrow-left mr-2"
                aria-hidden="true"
                onClick={onIsNewChatHide}
              ></i>
              New Chat
            </div>
          </div>
        </div>

        <div className="row composeBox">
          <div className="col-sm-12 composeBox-inner">
            <div className="form-group has-feedback">
              <input
                id="composeText"
                type="text"
                className="form-control"
                name="searchText"
                placeholder="Search People"
                value={searchUser}
                onChange={handleOnSearch}
              />
              <span className="glyphicon glyphicon-search form-control-feedback"></span>
            </div>
          </div>
        </div>

        <div className="row compose-sideBar">
          {newUsers?.map(
            (user, index) =>
              user?.id !== loginData?.id && (
                <div
                  className="row sideBar-body"
                  key={user.id}
                  onClick={() => isNavigate(`${user.id}`)}
                >
                  {/* <div className="col-sm-2 col-xs-3 sideBar-avatar">
                    <div className="avatar-icon">
                      <img
                        src={user.avatar ? user.avatar : defaultUserPic}
                        alt={user.userName}
                      />
                    </div>
                  </div> */}
                  <div className="col-sm-12 col-xs-12 sideBar-main">
                    <div className="mobilechatbox">
                      <div className="avatar-icon mobilechaiimg">
                        <img
                          src={user.avatar ? user.avatar : defaultUserPic}
                          alt={user.userName}
                        />
                      </div>
                      <div className="sideBar-name">
                        <span className="name-meta">{user.userName}</span>
                        {/* <div className="name-meta f-12">{user.lastMessage}</div> */}
                      </div>
                    </div>
                    {/* <div className="row d-none">
                      <div className="col-sm-9 col-xs-8 sideBar-name">
                        <span className="name-meta">{user.userName}</span>
                        <div className="name-meta f-12">{user.lastMessage}</div>
                      </div>
                      <div className="col-sm-3 col-xs-4 pull-right sideBar-time">
                    <span className="time-meta pull-right">{user.time}</span>
                  </div>
                    </div> */}
                  </div>
                </div>
              )
          )}
          <div className="panel-height-newuser"></div>
        </div>
      </div>
      {/*----------------Open group modal-------------------*/}
      {modalAction.createGroup && (
        <div className="modal-overlay">
          <NewGroup
            closeModal={closeModal}
            allUserList={usersData}
            loginUserData={loginData}
            action={"add"}
          />
        </div>
      )}

      {/*----------------view user profile modal-------------------*/}
      {modalAction?.viewProfile && (
        <div className="modal-overlay">
          <UserProfileModal
            title={`Profile`}
            closeModal={closeModal}
            user={loginData}
            // handleDelete={handleLeaveGroup}
            // modalBody={`Are you sure you want to Leave this group?`}
            // submitBtnLabel={"Leave"}
          />
        </div>
      )}
      {/*----------------view user profile modal-------------------*/}
      {modalAction.deleteCallLog && (
        <div className="modal-overlay">
          {/* <div className="modal-content">
            <h4>Delete Call Log</h4>
            <p>Are you sure you want to delete this call log?</p>
            <div className="modal-actions">
              <button className="btn btn-danger cancelbtn-mr5" onClick={confirmDeleteCallLog}>
                Delete
              </button>
              <button
                className="btn btn-secondary"
                onClick={() =>
                  setModalAction({ ...modalAction, deleteCallLog: false })
                }
              >
                Cancel
              </button>
            </div>
          </div> */}
          <Modal
            closeModal={closeModal}
            handleDelete={confirmDeleteCallLog}
            modalTitle={`Delete this Call Log`}
            modalBody={`Are you sure you want to Delete Call Log?`}
          />
        </div>
      )}
    </>
  );
};

export default ChatList;
